import { ProductCatalog } from '../constants/features';
import { usePlanFeatureGate } from './use-plan-feature-gate';

export const useProductCatalogFeatureGate = () => usePlanFeatureGate(ProductCatalog);
